import { render, staticRenderFns } from "./RepairPlanDetailPage.vue?vue&type=template&id=5be67e24&scoped=true&"
import script from "./RepairPlanDetailPage.vue?vue&type=script&lang=ts&"
export * from "./RepairPlanDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./RepairPlanDetailPage.vue?vue&type=style&index=0&id=5be67e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be67e24",
  null
  
)

export default component.exports